var e={REDIRECT:{ASSET_DASHBOARD:"Redirect - Asset Dashboard"}};export{e as MIXPANEL_ACTION_TYPES};
